import Footer from "components/Footer";
import Navbar from "components/Navbar";
import ProfileForm from "components/user/ProfileForm";
import { useEffect } from "react";
import { connect } from "react-redux";

import { fetchData } from "store/actions/dataAction";

const Profile = ({ fetchData, data }) => {
  const breadcrumb = [
    { pageTitle: "Home", pageHref: "/" },
    { pageTitle: "Profile", pageHref: "" },
  ];

  useEffect(() => {
    document.title = "Shoesnarian | Profile";

    if (!data.province)
      fetchData(
        `http://www.emsifa.com/api-wilayah-indonesia/api/provinces.json`,
        "province"
      );
  }, [fetchData, data]);

  return (
    <>
      <Navbar />
      <ProfileForm listProvince={data.province} breadcrumb={breadcrumb} />
      <Footer />
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    data: state.data,
  };
};

export default connect(mapStateToProps, { fetchData })(Profile);
